module.exports = __webpack_public_path__ + "static/img/Store-14.b54377ca.png";